export default function Pagination({ nowPage, totalPage, handlePageBtn }) {
  const tenDigits = Math.floor(nowPage / 10) * 10;

  const pageItemArr = Array.from({ length: totalPage - tenDigits < 10 ? totalPage % 10 : 10 }, (_, i) => ({
    key: `pageNum_${tenDigits + i}`,
    realPgae: tenDigits + i + 1,
    displayPage: tenDigits + i + 1,
    isOn: tenDigits + i === nowPage,
  }));

  return (
    <div id="CommonPagination" className="commonPagination">
      <ul className="pagination">
        <li className="first">
          <button type="button" className="btnFirst" value="firstPage" onClick={handlePageBtn} disabled={nowPage === 0}>
            <span className="sr-only">첫 페이지로 가기</span>
          </button>
        </li>
        <li className="prev">
          <button type="button" className="btnPrev" value="prevPage" onClick={handlePageBtn} disabled={nowPage === 0}>
            <span className="sr-only">이전 페이지로 가기</span>
          </button>
        </li>
        {pageItemArr.map((v) => (
          <li className={`num ${v.isOn && 'on'}`} key={v.key}>
            <button type="button" className="btnNum" value={v.realPgae} onClick={handlePageBtn}>
              {v.displayPage}
            </button>
          </li>
        ))}
        <li className="next">
          <button
            type="button"
            className="btnNext"
            value="nextPage"
            onClick={handlePageBtn}
            disabled={nowPage >= totalPage - 1}
          >
            <span className="sr-only">다음 페이지로 가기</span>
          </button>
        </li>
        <li className="last">
          <button
            type="button"
            className="btnLast"
            value="lastPage"
            onClick={handlePageBtn}
            disabled={nowPage >= totalPage - 1}
          >
            <span className="sr-only">마지막 페이지로 가기</span>
          </button>
        </li>
      </ul>
    </div>
  );
}
